var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterfacedownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36997 12.3734C8.86326 11.8764 9.66305 11.8764 10.1563 12.3734L16 18.2613L21.8437 12.3734C22.3369 11.8764 23.1367 11.8764 23.63 12.3734C24.1233 12.8705 24.1233 13.6763 23.63 14.1733L16.8932 20.9612C16.3999 21.4582 15.6001 21.4582 15.1068 20.9612L8.36997 14.1733C7.87668 13.6763 7.87668 12.8705 8.36997 12.3734Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfacedownArrow);
export default __webpack_public_path__ + "static/media/InterfacedownArrow.5b46230b02b5dca91518da8fbbaddaff.svg";
export { ForwardRef as ReactComponent };